import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogService } from '@hq-core/dialog/dialog.service';
import { DialogConfig } from '@hq-core/models/dialog';
import { UserService } from '@hq-core/user/user.service';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { ExportDialogComponent } from './export-dialog/export-dialog.component';
import { ExportDialogData, ExportOptions, ReportExportRequest } from './internal-export.model';
import { ReportExportResource } from './report-export.resource';

@Injectable({
    providedIn: 'root'
})
export class InternalExportService {

    constructor(
        private dialogService: DialogService,
        private userService: UserService,
        private snackBar: MatSnackBar,
        private reportExportResource: ReportExportResource
    ) { }

    openExportDialog(options: ExportOptions): Observable<boolean> {
        return this.userService.getCurrentUser().pipe(
            take(1),
            switchMap(user => {
                const dialogConfig = new DialogConfig();
                dialogConfig.component = ExportDialogComponent;
                dialogConfig.data = {
                    title: options.title,
                    emailAddress: user.profile?.email ?? '',
                    exportType: options.exportType,
                    brokerId: options.brokerId,
                    chainId: options.chainId,
                    chainStoreId: options.chainStoreId,
                    search: options.search
                } as ExportDialogData;

                return this.dialogService.show(dialogConfig);
            }),
            switchMap(result => {
                if (!result) {
                    return of(false);
                }
                return this.submitExport(result);
            })
        );
    }

    private submitExport(request: ReportExportRequest): Observable<boolean> {
        return this.reportExportResource.create(request).pipe(
            map(() => {
                this.snackBar.open(
                    "Export queued. You'll receive an email shortly.",
                    null,
                    { duration: 5000 }
                );
                return true;
            }),
            catchError(() => {
                this.snackBar.open(
                    'Failed to queue export. Please try again.',
                    null,
                    { duration: 5000 }
                );
                return of(false);
            })
        );
    }
}
